import { useNavigate } from "react-router";

import { useDispatch } from "react-redux";

import InboxIcon from "../../images/Inbox/email.png";
import { goToDetailPage } from "../../redux/action/action";
import { Base64 } from "js-base64";
import { storeInboxDetail } from "../../redux/action/member/memberAction";

const InboxItem = ({ data, isInbox }) => {
  const { createDate, subject, message, marContent, uid } = data;

  const encodeMessage = encodeURIComponent(message);
  const encodeMark = Base64?.encode(marContent);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  return (
    <div
      className="bg-transaction-card dark:bg-base-light-dark p-common-padding-x rounded-lg flex gap-[10px] mb-[10px] cursor-pointer"
      onClick={() => {
        navigate(`${uid}`);
        dispatch(
          storeInboxDetail({
            subject,
            message,
            createDate,
            uid,
            isInbox: isInbox ? "1" : "0",
          })
        );
        dispatch(goToDetailPage());
      }}
    >
      <div className="w-[20px] flex items-center justify-center">
        <div
          className={`w-[8px] h-[8px] rounded-full ${
            data.readmsg == 0 ? "bg-main-color" : "bg-[#32383E]"
          }`}
        ></div>
      </div>
      <div className="flex flex-col justify-between gap-[5px]">
        <p className="font-medium text-dark-gray-text dark:text-base-white mb-0">
          {subject}
        </p>
        <p className="font-medium text-sm text-light-text text-overflow mb-0">
          {createDate}
        </p>
      </div>
    </div>
  );
};

export default InboxItem;
